import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './user.service';
import { SsApiService } from '../api/ss-api.service';
import {
  ALL_WELCOME_OFFERS_USED,
  ALL_WELCOME_OFFERS_USED_FOR_STAG,
  THREE_PACK_ALL_WELCOME_OFFERS_USED
} from "./data/user-group.data";
import { isArray } from '../../helpers/utils';

@Injectable({
  providedIn: 'root',
})
export class UserGroupsService {
  private _ssApi = inject(SsApiService);
  private _user = inject(UserService);


  /**
   * Add user to provided group
   * @param group
   */
  public addToGroup(group: any | string[]): Observable<any> {
    return this._ssApi.postPlayerGroups({
      groups: {
        add: isArray(group) ? group : [group],
      },
    });
  }

  /**
   * Remove user from provided group
   * @param group
   */
  public removeFromGroup(group: any | string[]): Observable<any> {
    return this._ssApi.postPlayerGroups({
      groups: {
        remove: isArray(group) ? group : [group],
      },
    });
  }

  /**
   * Is exist group in user`s groups
   * @param group
   */
  public isExistGroup(groupId: number | string): boolean {
    if (!this._user.auth || !this._user.info.statuses.length) {
      return null;
    }
    return Boolean(this._user.info.statuses.find(status => status.id === groupId));
  }

  /**
   * Check already added user group
   * @param status
   * @param statuses
   */
  public alreadyExistUserGroup(status: any, statuses: any[]): boolean {
    return statuses && statuses.some(item => item.id.includes(status));
  }

  public isAllWelcomeUsed(): boolean {
    return this.isExistGroup(ALL_WELCOME_OFFERS_USED) ||
      this.isExistGroup(THREE_PACK_ALL_WELCOME_OFFERS_USED) ||
      this.isExistGroup(ALL_WELCOME_OFFERS_USED_FOR_STAG)
  }

}
